import { Component } from 'react';
import MainPost from './MainPost';
import { API_BASE } from '../../../config/api';

class Team extends Component {
	constructor(props) {
        super(props);
        this.state = {
            team: [],
            loading: true
        };
    }

    componentDidMount() {
        fetch(`${API_BASE}/team`)
            .then(res => res.json())
            .then(data => this.setState({ team: Array.isArray(data) ? data : [], loading: false }))
            .catch(() => this.setState({ team: [], loading: false }));
    }

    render() {
        const { team, loading } = this.state;

        if (loading) {
            return (
                <section className="flat-row pd-about-post">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12" style={{ padding: '40px', textAlign: 'center', color: '#666' }}>
                                Loading team…
                            </div>
                        </div>
                    </div>
                </section>
            );
        }

        return (
			<section className="flat-row pd-about-post modern-profile-section">
                <div className="container">
                    <div className="row flat-tabs" data-effect="fadeIn">
                        <MainPost team={team} />
                    </div>
                </div>
            </section>
        );
    }
}

export default Team;
